import Definitions from "../../http_request/Model/Definitions/Definitions";
import {toast} from "react-toastify";

export const getFilterRows = (setFilterLocation, setLoading,id,callbackError) => {
    Definitions.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (data) => {

            setFilterLocation(data);
        },
        error: ({error}) => {
            toast.error(error.data.message);
            callbackError && callbackError()
        },

        final: (data) => {
            setLoading(data);
        },
    }).addParams(id ? {id} : {}).FilterRows();
};
